<div class="b-window" (mouseenter)="mouseEnter()"  (mouseleave)="mouseLeave()">
  <div class="a-content sk-theme-dark">
      @if (showNavigationMenuSearch()) {
        <div class="navigation-menu-search">
          <button type="button"
                  class="global-navigation-menu-search-button"
                  data-test="global-navigation-menu-search-button"
                  [attr.aria-label]="'label.Search' | translate"
                  [matTooltip]="'label.Search' | translate"
                  matTooltipPosition="after"
                  (click)="openSearch()">
            <i class="sk-icon sk-icon-search"></i>
          </button>

          <sk-text class="global-navigation-menu-search-input"
                   data-test="global-navigation-menu-search-input"
                   stylingMode="filled"
                   [noSubscriptBox]="true"
                   [showClear]="true"
                   [placeholder]="'label.TypeToSearch' | translate"
                   [formControl]="searchControl"
                   (keydown.escape)="handleSearchEscape($event)">
          </sk-text>
        </div>

      }
  </div>

  <div class="b-content">
    <div class="scrollable" #scrollBox>
      <ng-template #menuItemTitle let-title>
        @for (part of getHighlightedTitle(title); track $index) {
          @if (part.match) {
            <mark>{{ part.text }}</mark>
          } @else {
            <span>{{ part.text }}</span>
          }
        }
      </ng-template>

      <mat-tree class="iris-menu-list"
                #tree
                [dataSource]="filteredNavigationMenu()"
                [childrenAccessor]="childrenAccessor">
        <mat-nested-tree-node *matTreeNodeDef="let menuItem" class="menu-item-container" [class.active]="menuItem.$active" [class.has-new-functionality]="menuItem.newFunctionalityConfig">
          @if (!getUi2SubPathOrNull(menuItem.url)) {
            <a class="menu-item"
               [attr.data-test]="'global-nav-menu-item-' + menuItem.name + '-link'"
               [href]="menuItem.url"
               (click)="handleMenuClick($event, menuItem)"
               [matTooltip]="showTooltipIfNeeded(menuItem)"
               [matTooltipPosition]="'after'">
              <span class="menu-item-icon">
                <i class="fa-fw {{ menuItem.icon }}"></i>
              </span>
              <span class="menu-item-caption">
                <ng-container [ngTemplateOutlet]="menuItemTitle"
                              [ngTemplateOutletContext]="{ $implicit: menuItem.$title }">
                </ng-container>
              </span>
            </a>

          } @else {
            <a class="menu-item position-relative"
               [attr.data-test]="'global-nav-menu-item-' + menuItem.name + '-link'"
               [routerLink]="[getUi2SubPathOrNull(menuItem.url)]"
               (click)="handleMenuClick($event, menuItem)"
               [matTooltip]="showTooltipIfNeeded(menuItem)"
               [matTooltipPosition]="'after'">
                <span class="menu-item-icon">
                  <i class="fa-fw {{ menuItem.icon }} position-relative">
                    @if (menuItem.name === 'email-client' && !!emailUnreadMessagesCount()) {
                      <span class="position-absolute top-0 start-100 translate-middle p-1 bg-danger badge-color rounded-circle">
                        <span class="visually-hidden">New alerts</span>
                      </span>
                    }
                  </i>
                </span>
                <span class="menu-item-caption">
                  <ng-container [ngTemplateOutlet]="menuItemTitle"
                                [ngTemplateOutletContext]="{ $implicit: menuItem.$title }">
                  </ng-container>
                </span>
                @if (menuItem.name === 'email-client' && !!emailUnreadMessagesCount()) {
                  <span class="emails-count text-center">
                    {{ emailUnreadMessagesCount() }}
                  </span>
                }
            </a>
          }

          @if (menuItem.newFunctionalityConfig) {
            <iris-new-functionality-button [config]="menuItem.newFunctionalityConfig"></iris-new-functionality-button>
          }

        </mat-nested-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let menuItem; when: hasChild"
                              class="menu-item-container"
                              [class.active]="menuItem.$active"
                              [class.expanded]="tree.isExpanded(menuItem)">
          <button class="menu-item"
                  [attr.data-test]="'global-nav-menu-item-' + menuItem.name + '-button'"
                  (click)="toggleSubMenu(menuItem)"
                  [matTooltip]="showTooltipIfNeeded(menuItem)"
                  [matTooltipPosition]="'after'">
            <span class="menu-item-icon">
              <i class="fa-fw {{ menuItem.icon }}"></i>
            </span>
            <span class="menu-item-caption">
              <ng-container [ngTemplateOutlet]="menuItemTitle"
                            [ngTemplateOutletContext]="{ $implicit: menuItem.$title }">
              </ng-container>
            </span>
            <span class="menu-item-more">
              <i class="fal"
                [class.fa-chevron-down]="!tree.isExpanded(menuItem)"
                [class.fa-chevron-up]="tree.isExpanded(menuItem)"
              ></i>
            </span>
          </button>

          <div [@slideVertical]="tree.isExpanded(menuItem) ? 'show' : null"
               class="menu-group-container">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </div>
  </div>

  <div class="b-footer">
    <div class="btn-toolbar">
      <sk-toggle
        class="iris-menu-pin sk-theme-dark"
        data-test="global-nav-pin-toggle"
        [stylingMode]="'unformed'"
        [label]="'label.PinMainMenu' | translate"
        [labelPosition]="'before'"
        [ngModel]="pinned"
        (ngModelChange)="togglePinned($event)"
      ></sk-toggle>
    </div>
  </div>
</div>
